import { Pipe, PipeTransform } from '@angular/core';
import { getMeetingAuditFieldTooltip } from '@app/shared/utils/helper';

/**
 * Returns a tooltip description for a given audit field attribute name.
 * Example: 'host_key' -> 'Six-digit PIN to claim host during a meeting'
 */
@Pipe({
  name: 'auditFieldTooltip',
  standalone: true,
  pure: true,
})
export class AuditFieldTooltipPipe implements PipeTransform {
  public transform(attributeName: string): string {
    return getMeetingAuditFieldTooltip(attributeName);
  }
}
